<template>
<div class="containers">
    <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
    </CAlert>
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol sm="12">
                <span class="font-weight-bold" style="color:rgba(0, 0, 0, 1);font-size:18px">
                    Administrator
                </span>
                <hr style="border: 1px solid rgba(224, 224, 224, 1)"/>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="10">
            </CCol>
            <CCol sm="2">
                <CButton @click="addData()" type="button" class="btn btn-add">Tambah</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <!-- <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/> -->
                <!-- <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/> -->
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" @edit="editData" @delete="deleteData" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="editModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Update Admin</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="editModal = false, deviceAlasan = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="6">
                        <label>Nama</label>
                        <div class="autocomplete">
                            <input type="text" disabled class="form-control" v-model="namaPegawai" />
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Perusahaan</label>
                        <model-select :options="dataPerusahaan"
                            class="form-control model-select"
                            v-model="perusahaan"
                            placeholder="Pilih Perusahaan">
                        </model-select>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol class="text-right" sm="12">
                    <CButton @click="editModal = false" class="modal-buttons modal-button-cancel mr-1">Kembali</CButton>
                    <CButton @click="onSubmit()" class="modal-buttons modal-button-simpan ml-1">
                        <span v-if="loading == false">Update</span>
                        <CSpinner v-else color="default" size="sm"/>
                    </CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="addModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Add Data Admin</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="addModal = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Nama</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    :disabled="tipe == 'U' || tipe=='u'"
                                    @click="toggleVisiblePegawai()"
                                    @blur="toggleCloseVisiblePegawai()"
                                    :class="{ 'is-invalid':$v.queryPegawai.$error, 'is-valid': !$v.queryPegawai.$invalid }"
                                    v-model.trim="$v.queryPegawai.$model"
                                    v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                    @keydown.up="upPegawai"
                                    @keydown.down="downPegawai"
                                    @keydown.enter="selectItemPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visiblePegawai">
                                <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPegawai"
                                        :key="index"
                                        :class="{ 'selected': (selectedPegawai == index)}"
                                        @click="itemClickedPegawai(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol class="text-right" sm="12">
                    <CButton @click="addModal = false" class="modal-buttons modal-button-cancel mr-1">Kembali</CButton>
                    <CButton @click="submitForm('C')" class="modal-buttons modal-button-simpan ml-1">
                        <span>Tambah</span>
                    </CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="sm"
        :centered="true"
        title="Info Delete"
        color="danger"
        :show.sync="deleteModal"
        >
        <p>Apakah anda yakin ingin menghapus data?</p>
        <CRow>
            <CCol sm="6">
                <CButton @click="cancelDelete()" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
            </CCol>
            <CCol sm="6">
                <CButton @click="submitForm('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
            </CCol>
        </CRow>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tableAdmin'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    components: {
        Tables,
        ModelSelect,
    },
    mixins: [validationMixin],
    validations: {
        queryPegawai: {
            required
        },
    },
    data() {
        return {
            editModal: false,
            addModal: false,
            deleteModal: false,
            // data search select pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawaiAdd: '',

            // data search pegawai
            namaPegawai: '',
            idPegawai: '',

            // perusahaan
            dataPerusahaan: [],
            perusahaan: {
                value: '',
                text: ''
            },

            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama', 'Email', 'Perusahaan', 'Action'],
            dataTd: ['nama', 'email', 'namaPerusahaan', 'action'],
            styleTable: ['200px', '200px', '200px', '200px'],
            classReload: 'reloadOff',
            datas: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            goArea: true,
            loading: false,
            success: '',
            alertMess: '',
            currentAlertCounter: 0,


            // error
            errorMessage: '',            
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    watch: {
        page() {
            this.getData()
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawaiAdd = ''
            }
            this.getDataPegawai()
        },
    },
    methods: {
        /**
         * SEARCH PERUSAHAAN
         */
        getDataPerusahaan() {
            let payload = {
                limit: 9999,
                namaOrganisasi: '',
                organisasi: "",
                pageIn: 1
            }
            DataApi.post("perusahaan/get", payload)
            .then(res => {
                this.dataPerusahaan = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                let onPush = ''
                for(i=0;i<tempData.length;i++) {
                    onPush = {
                        value: tempData[i].kode,
                        text: tempData[i].nama
                    }
                    this.dataPerusahaan.push(onPush)
                }
            })
        },

        /**
         * SEARCH SELECT PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawaiAdd = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },


        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.email.toLowerCase() < b.email.toLowerCase()) {
                        return -1
                    }
                    if (a.email.toLowerCase() > b.email.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.namaPerusahaan.toLowerCase() < b.namaPerusahaan.toLowerCase()) {
                        return -1
                    }
                    if (a.namaPerusahaan.toLowerCase() > b.namaPerusahaan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/pegawai/admin")
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                    // this.dataDownload()
                } else {
                    this.datas = []
                    this.errorMessage = response.message
                }
                this.$store.state.loadingScreen = false
            })
        },

        addData() {
            this.queryPegawai = ''
            this.idPegawaiAdd = ''
            this.addModal = true
        },

        editData(val) {
            this.namaPegawai = this.datas[val].nama
            this.idPegawai = this.datas[val].idPegawai
            this.editModal = true
            let data = this.dataPerusahaan
            var i = 0
            for(i=0;i<data.length;i++) {
                if(this.datas[val].kodePerusahaan == data[i].value) {
                    this.perusahaan.value = data[i].value
                    this.perusahaan.text = data[i].text
                }
            }
        },
        onSubmit() {
            this.loading = true
            let payload = {
                idPegawai: this.idPegawai,
                organisasi: this.perusahaan.value
            }
            DataApi.post("pegawai/perusahaan/update", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.loading = false
                this.currentAlertCounter = 7
                this.getData()
                this.editModal = false
                this.perusahaan.value = ''
                this.perusahaan.text = ''
                this.getDataPerusahaan()
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchValue = ''
            this.selectedBulan.value = ''
            this.selectedBulan.text = ''
            this.getDataBulan()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        submitForm(val) {
            if(val == 'C') {
                this.$v.$touch()
                if(this.$v.$invalid) {
                } else {
                    this.goSave(val)
                }
            } else {
                this.goSave(val)
            }
        },
        goSave(val) {
            let payload = {
                idPegawai: this.idPegawaiAdd,
                type: val
            }
            DataApi.post("pegawai/pegawai/admin/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.loading = false
                this.currentAlertCounter = 7
                this.getData()
                this.addModal = false
                this.deleteModal = false
                this.perusahaan.value = ''
                this.perusahaan.text = ''
                this.queryPegawai = ''
                this.idPegawaiAdd = ''
                this.getDataPegawai()
                this.getDataPerusahaan()
            })
        },
        cancelDelete() {
            this.deleteModal = false
        },
        deleteData(val) {
            this.idPegawaiAdd = this.datas[val].idPegawai
            this.deleteModal = true
        }
    },
    mounted() {
        this.getDataPerusahaan()
        this.getData()
        this.getDataPegawai()
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}

</style>